export const toCrowdStrikeInputCreateRequest = ({
  crowdstrikeName,
  crowdstrikeStoreFullMessage,
  crowdstrikeThrottleEnabled,
  checkpointIntervalSeconds,
  crowdstrikeClientId,
  crowdstrikeClientSecret,
  crowdstrikeBaseUrl
}) => ({
  name: crowdstrikeName.value,
  checkpoint_interval_seconds: checkpointIntervalSeconds.value,
  store_full_message: !!(crowdstrikeStoreFullMessage == null ? void 0 : crowdstrikeStoreFullMessage.value),
  enable_throttling: !!(crowdstrikeThrottleEnabled == null ? void 0 : crowdstrikeThrottleEnabled.value),
  crowdstrike_base_url: crowdstrikeBaseUrl.value,
  crowdstrike_client_id: crowdstrikeClientId.value,
  crowdstrike_client_secret: crowdstrikeClientSecret.value
});
export const toGenericInputCreateRequest = ({
  crowdstrikeName,
  crowdstrikeStoreFullMessage,
  crowdstrikeThrottleEnabled,
  crowdstrikeClientId,
  crowdstrikeClientSecret,
  crowdstrikeBaseUrl,
  checkpointIntervalSeconds
}) => ({
  type: "org.graylog.enterprise.integrations.crowdstrike.CrowdStrikeInput",
  title: crowdstrikeName.value,
  global: false,
  configuration: {
    checkpoint_interval_seconds: checkpointIntervalSeconds.value,
    store_full_message: !!(crowdstrikeStoreFullMessage == null ? void 0 : crowdstrikeStoreFullMessage.value),
    throttling_allowed: !!(crowdstrikeThrottleEnabled == null ? void 0 : crowdstrikeThrottleEnabled.value),
    crowdstrike_base_url: crowdstrikeBaseUrl.value,
    crowdstrike_client_id: crowdstrikeClientId.value,
    crowdstrike_client_secret: crowdstrikeClientSecret.value
  }
});
